module.exports = __webpack_public_path__ + "img/EventWinPage01082.eaf49527.png";